<ion-content [scrollY]="false">
  <ion-picker>
    <ion-picker-column [value]="hours" (ionChange)="onColumnChange('hours', $event)">
      @for (opt of hoursOptions; track opt.value) {
        <ion-picker-column-option [value]="opt.value">
          {{ opt.text }}
        </ion-picker-column-option>
      }
    </ion-picker-column>
    <ion-picker-column [value]="minutes" (ionChange)="onColumnChange('minutes', $event)">
      @for (opt of minutesOptions; track opt.value) {
        <ion-picker-column-option [value]="opt.value">
          {{ opt.text }}
        </ion-picker-column-option>
      }
    </ion-picker-column>
    <ion-picker-column [value]="seconds" (ionChange)="onColumnChange('seconds', $event)">
      @for (opt of secondsOptions; track opt.value) {
        <ion-picker-column-option [value]="opt.value">
          {{ opt.text }}
        </ion-picker-column-option>
      }
    </ion-picker-column>
  </ion-picker>
</ion-content>

<ion-footer class="fixed">
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col>
          <yu-button color="gradient" type="outline" expand="block" (yuClick)="cancel()">
            {{ 'COMMON.CANCEL' | translate }}
          </yu-button>
        </ion-col>
        <ion-col>
          <yu-button color="gradient" expand="block" (yuClick)="confirm()">
            {{ 'COMMON.SAVE' | translate }}
          </yu-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
